import React, { useState } from "react";
import Nav from "./Nav";
import Footer from "./Footer";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    AOS.init();
  }, []);

  const send = async (e) => {
    e.preventDefault();
    if (!name || !email || !number || !message) {
      toast.error("Please enter complete details");
    } else {
      const payload = {
        name,
        email,
        number,
        message,
      };
      try {
        await axios.post(
          `https://video-editing-api.herokuapp.com/contact`,
          payload
        );
        toast.success("Your message has been send successfully");
        setEmail(" ");
        setNumber(" ");
        setName("");
        setMessage(" ");
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const navigate = useNavigate();
  return (
    <div>
      <Nav active="contact" />
      <div className="bg-[#fff] pb-20">
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="1000"
          className=" max-w-[1000px] mx-auto px-5 pt-10 pb-20"
        >
          <h1 className="md:text-[45px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
            Get in touch
          </h1>
          <p className="mt-4 mb-6 text-2xl  text-[#4f4f4f] text-center ">
            We aim to reply within 24 hours{" "}
          </p>
          <form onSubmit={send}>
            <div className="">
              <div className="flex-wrap items-center justify-between lg:flex">
                <div className="flex-grow   lg:max-w-[450px] my-4 md:my-0">
                  <label
                    htmlFor="name"
                    className="block my-3 text-[21px] font-semibold"
                  >
                    Your name
                  </label>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    className="w-[100%] transition-all duration-300 ease-out bg-gray-200 focus:bg-gray-300 outline-none text-[20px] p-3 rounded-sm -none"
                  />
                </div>
                <div className="flex-grow  lg:max-w-[450px]  my-4 md:my-0">
                  <label
                    htmlFor="name"
                    className="block my-3 text-[21px] font-semibold"
                  >
                    Telephone (inc area code)
                  </label>
                  <input
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                    type="text"
                    placeholder="+1"
                    className="w-[100%] transition-all duration-300 ease-out bg-gray-200 focus:bg-gray-300 outline-none text-[20px] p-3 rounded-sm -none"
                  />
                </div>
              </div>
              <div className="flex-grow my-8">
                <label
                  htmlFor="name"
                  className="block my-3 text-[21px] font-semibold"
                >
                  Your email
                </label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  className="w-[100%] transition-all duration-300 ease-out bg-gray-200 focus:bg-gray-300 outline-none text-[20px] p-3 rounded-sm -none"
                />
              </div>
              <div className="flex-grow my-6">
                <label
                  htmlFor="name"
                  className="block my-3 text-[21px] font-semibold"
                >
                  Your message
                </label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  type="text"
                  className="w-[100%] transition-all duration-300 ease-out resize-none bg-gray-200 focus:bg-gray-300 outline-none text-[20px] p-3 rounded-sm -none"
                />
              </div>
            </div>
            <button
              type="submit"
              className="px-8 p-3 m-1 mt-2 text-xl font-semibold bg-[#508dff]  transition duration-200 ease-out text-[#fff] rounded-md text-center mx-auto hover:shadow-2xl"
            >
              Send
            </button>
          </form>
        </div>

        <div className="max-w-[1320px] flex flex-wrap justify-around lg:justify-between mx-auto md:px-0 px-4">
          <div className="bg-[#1b0c3e] p-20 max-w-[600px] flex-grow">
            <h1 className="mb-4 text-3xl font-semibold text-center text-white ">
              Have questions?
            </h1>
            <div className="text-center">
              <button
                onClick={() => navigate("/FAQs")}
                className="p-3 m-1 mt-2 text-xl font-semibold text-white transition duration-200 ease-out bg-[#357cff] rounded-sm md:px-6 "
              >
                Check our FAQs
              </button>
            </div>
          </div>
          <div className="bg-[#508dff] p-20 max-w-[600px] flex-grow">
            <h1 className="mb-4 text-3xl font-semibold text-center text-[#fff] ">
              Ready to start?
            </h1>
            <div className="text-center">
              <button
                onClick={() => navigate("/content-creators")}
                className="p-3 text-white rounded-sm m-1 mt-2 text-xl font-semibold text-[#] transition duration-200 ease-out bg-[#1b0c3e] md:px-6 "
              >
                Register here
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </div>
  );
};

export default Contact;
